<template>
  <div v-if="watched.length > 0" class="summary watching-summary">
    <h2>Watching</h2>

    <h3>Movies</h3>
    <ol class="watching-list">
      <li v-for="(watching, index) in watched" :key="index"
          class="watching">
        <img :src="watching.thumbnail" class="pull-left movie-cover">
        <div class="pull-right">
          <a class="watching-title"
             :href="watching.url">
            {{ watching.title }}
          </a>
        </div>
        <div style="clear:both;"></div>
      </li>
    </ol>
  </div>
</template>

<style lang="stylus" scoped>
.watching-list
  list-style none
  padding 0px
  margin 0px

.pull-left
  float left

.pull-right
  float right
  display block
  width 65%

.movie-cover
  display: block
  width 33%

.watching
  display block
  padding-top 2px
  padding-bottom 2px
  border-bottom 1px solid var(--border)

.watching-title
  width 80%
</style>

<script>
export default {
  name: 'Watching',
  inject: ['getEvents'],
  components: {},
  data() {
    return {
      watched: [],
    }
  },
  async created() {
    const events = await this.getEvents

    for (const event of events) {
      if (
        event.feed.short_name === 'letterboxd'
      ) {

        console.log(event.raw)
        this.watched.push({
          url: event.link,
          title: event.title + ' (' + event.raw['letterboxd:filmYear'] + ')',
          thumbnail: event.original.path
        })
      }
    }
  }
}
</script>